module.exports = __webpack_public_path__ + "img/wangrui.2df15e08.png";